export default "__VITE_ASSET__CKRfBO4Z__"